import React, { useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { formatCurrency } from '../shared/utils'
import AlternativesModal from './AlternativesModal'

const RecommendationsSearchResults = ({
  results,
  lazyState,
  rowsPerPageOptions,
  onLazyPage,
  totalCount,
  tableLoading,
  handleResultsUpdate
}) => {
  const [localResults, setLocalResults] = useState([])
  const [alternativesVisible, setAlternativesVisible] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState(null)

  const strengthBodyTemplate = (rowData) => {
    // Try to extract strength from itemDescription if strength field doesn't exist
    let strength = rowData.strength || rowData.drugStrength;
    if (!strength && rowData.itemDescription) {
      const strengthMatch = rowData.itemDescription.match(/\[Strength:\s*([^\]]+)\]/i);
      if (strengthMatch) {
        strength = strengthMatch[1].trim();
      }
    }
    return (
      <div>
        {strength || 'N/A'}
      </div>
    )
  }

  const handleCheckAlternatives = (product) => {
    setSelectedProduct(product)
    setAlternativesVisible(true)
  }

  const alternativesBodyTemplate = (rowData) => {
    return (
      <div className='d-flex justify-content-center'>
        <Button
          type='button'
          label='Alternatives'
          onClick={() => handleCheckAlternatives(rowData)}
        />
      </div>
    )
  }

  useEffect(() => {
    if (results) {
      setLocalResults(results)
    }
  }, [results])

  const handlePageChange = (e) => {
    onLazyPage({
      first: e.first,
      rows: e.rows,
      page: e.page,
    })
  }

  return (
    <>
      <DataTable
        value={localResults}
        paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
        rowsPerPageOptions={rowsPerPageOptions}
        totalRecords={totalCount || 0}
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        rows={lazyState.rows}
        paginator
        lazy
        first={lazyState.first}
        onPage={(e) => {
          handlePageChange(e);
        }}
        showGridlines
        loading={tableLoading}
        dataKey='id'
        removableSort
        emptyMessage={() => {
          return (
            <div
              style={{
                height: '365px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <span style={{ fontWeight: '400' }}>
                {tableLoading 
                  ? 'Loading...' 
                  : localResults?.length === 0 
                    ? 'No results found' 
                    : 'Use the search bar to find products'
                }
              </span>
            </div>
          )
        }}
      >
        <Column field='retailUpcCode' header='UPC#' />
        <Column field='itemDescription' header='Product Description' />
        <Column field='manufacturer.name' header='Manufacturer' />
        <Column 
          field='drugIdentificationNo' 
          header='DIN/NPN'
          body={(rowData) => {
            const din = rowData.drugIdentificationNo
            if (din == null || din === '') return din
            return String(din).padStart(8, '0')
          }}
        />
        <Column header='Strength' body={strengthBodyTemplate} />
        <Column header='Price' body={(e) => formatCurrency(e.sellingPrice)} />
        <Column body={alternativesBodyTemplate} header='PA Navigator' style={{ minWidth: '200px' }} />
      </DataTable>
      <AlternativesModal
        visible={alternativesVisible}
        setVisible={setAlternativesVisible}
        product={selectedProduct}
        includeOdPaAdvantage={false}
        showGuidanceDisclaimer
      />
    </>
  )
}

export default RecommendationsSearchResults

